import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home.vue'
import HomeDark from '../views/HomeDark.vue'
import GetMqGame from '../views/GetMqGame.vue'
import Login from '../views/Login.vue'
import GameDetail from '../views/GameDetail.vue'
import GameMoQuDetail from '../views/GameMoQuDetail.vue'
import HotRanking from '../views/HotRanking.vue'
import Layout from '../views/Layout.vue'
import LayoutDark from '../views/LayoutDark.vue'
import Mine from '../views/Mine.vue'
import ManageLayout from '../views/ManageLayout.vue'
import StaffManagement from '../views/StaffManagement.vue'
import GameManagement from '../views/GameManagement.vue'
import CardManageMent from '../views/CardManagement.vue'
import HistoryDownload from '../views/HistoryDownload.vue'
import MqHistoryDownload from '../views/MoquHistoryDownload.vue'
import MoquAccountManage from '../views/MoquAccountManage.vue'
import MoquGameManagement from '../views/MoquGameManagement.vue'
import MoquDirectLimitConfig from '../views/MoquDirectLimitConfig.vue'
import UserRiskMonitor from '../views/UserRiskMonitor.vue'
import Pan123TokenManagement from '../views/Pan123TokenManagement.vue'
import Pan123CacheManagement from '../views/Pan123CacheManagement.vue'
import ProxyDownloadLogs from '../views/ProxyDownloadLogs.vue'
import UrlDownloadLogs from '../views/UrlDownloadLogs.vue'
import TianyiManagement from '../views/TianyiManagement.vue'
import TianyiAutoUploadConfig from '../views/TianyiAutoUploadConfig.vue'
import TianyiDirectRequests from '../views/TianyiDirectRequests.vue'
import AgentLayout from '../views/AgentLayout.vue'
import LinkSetting from '../views/LinkSetting.vue'
import SystemConfig from '../views/SystemConfig.vue'
Vue.use(Router)
const routes = [
    // 深色主题路由（默认）
    {
        path: '/', component: LayoutDark,
        children: [
            {
                path: '/',
                component: HomeDark,
                name: 'Home',
                meta: {
                    title: '首页'
                }
            },
            {
                path: 'GetMqGame',
                component: GetMqGame,
                name: 'GetMqGame',
                meta: {
                    title: 'VR游戏解析'
                }
            },
            {
                path: 'hotRanking',
                component: HotRanking,
                name: 'HotRanking',
                meta: {
                    title: '热门游戏排行榜'
                }
            },
            {
                path: 'mine',
                component: Mine,
                name: 'Mine',
                meta: {
                    title: '我的'
                }
            },
        ]
    },
    // 浅色主题路由（备用）
    {
        path: '/light', component: Layout,
        children: [
            {
                path: '/',
                component: Home,
                name: 'HomeLight',
                meta: {
                    title: '首页 - 浅色主题'
                }
            },
            {
                path: 'GetMqGame',
                component: GetMqGame,
                name: 'GetMqGameLight',
                meta: {
                    title: 'VR游戏解析'
                }
            },
            {
                path: 'hotRanking',
                component: HotRanking,
                name: 'HotRankingLight',
                meta: {
                    title: '热门游戏排行榜'
                }
            },
        ]
    },
    { path: '/login', component: Login, name: 'Login', },

    {
        path: '/gameDetail/:id', component: Layout,
        children: [
            {
                path: '/',
                component: GameDetail,
                name: 'GameDetail',
                meta: {
                    title: '游戏详情'
                }
            },
        ]
    },
    {
        path: '/gameMqDetail/:id', component: LayoutDark,
        children: [
            {
                path: '/',
                component: GameMoQuDetail,
                name: 'GameMoQuDetail',
                meta: {
                    title: '游戏详情'
                }
            },
        ]
    },
    {
        path: '/manage',
        component: ManageLayout,
        meta: {
            requiresAdmin: true // 添加需要管理员权限的标记
        },
        children: [
            {
                path: 'staff',
                component: StaffManagement,
                meta: {
                    requiresAdmin: true
                }
            },
            {
                path: 'game',
                component: GameManagement,
                meta: {
                    requiresAdmin: true
                }
            },
            {
                path: 'card',
                component: CardManageMent,
                meta: {
                    requiresAdmin: true
                }
            },
            {
                path: 'historyDownload',
                component: HistoryDownload,
                meta: {
                    requiresAdmin: true
                }
            },
            {
                path: 'mqHistoryDownload',
                component: MqHistoryDownload,
                meta: {
                    requiresAdmin: true
                }
            },
            {
                path: 'moquAccountManage',
                component: MoquAccountManage,
                meta: {
                    requiresAdmin: true
                }
            },
            {
                path: 'moquGameManage',
                component: MoquGameManagement,
                meta: {
                    requiresAdmin: true
                }
            },
            {
                path: 'moquDirectLimit',
                component: MoquDirectLimitConfig,
                meta: {
                    requiresAdmin: true
                }
            },
            {
                path: 'userRiskMonitor',
                component: UserRiskMonitor,
                meta: {
                    requiresAdmin: true
                }
            },
            {
                path: 'pan123Token',
                component: Pan123TokenManagement,
                meta: {
                    requiresAdmin: true
                }
            },
            {
                path: 'pan123Cache',
                component: Pan123CacheManagement,
                meta: {
                    requiresAdmin: true
                }
            },
            {
                path: 'proxyDownloadLogs',
                component: ProxyDownloadLogs,
                meta: {
                    requiresAdmin: true
                }
            },
            {
                path: 'urlDownloadLogs',
                component: UrlDownloadLogs,
                meta: {
                    requiresAdmin: true
                }
            },
            {
                path: 'tianyi',
                component: TianyiManagement,
                meta: {
                    requiresAdmin: true
                }
            },
            {
                path: 'tianyiAutoUploadConfig',
                component: TianyiAutoUploadConfig,
                meta: {
                    requiresAdmin: true
                }
            },
            {
                path: 'tianyiDirectRequests',
                component: TianyiDirectRequests,
                meta: {
                    requiresAdmin: true
                }
            }
        ]
    },
    {
        path: '/agent',
        component: AgentLayout,
        meta: {
            requiresAgent: true // 添加需要管理员权限的标记
        },
        children: [
            {
                path: 'linkSetting',
                component: LinkSetting,
                meta: {
                    requiresAgent: true
                }
            },
            {
                path: 'systemConfig',
                component: SystemConfig,
                meta: {
                    requiresAgent: true
                }
            },
        ]
    }
]

const router = new Router({
    mode: 'history',
    routes
})

// 添加全局导航守卫
router.beforeEach((to, from, next) => {
    // 从 localStorage 或 Vuex 获取用户信息
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')

    // 检查路由是否需要管理员权限
    if (to.matched.some(record => record.meta.requiresAdmin)) {
        if (userInfo.role === 'admin') {
            next() // 是管理员，允许访问
        } else {
            next('/login') // 不是管理员，重定向到登录页
        }
    }
    // 检查路由是否需要代理权限
    else if (to.matched.some(record => record.meta.requiresAgent)) {
        if (userInfo.role === 'agent' || userInfo.role === 'admin') {
            next() // 是代理或管理员，允许访问
        } else {
            next('/login') // 不是代理或管理员，重定向到登录页
        }
    }
    else {
        next() // 不需要权限的路由，直接通过
    }
})

export default router
